import { volunteerOrganizationContactRepo } from "@repositories";
import {
  normalizeVolunteerOrgContactDrafts,
  type VolunteerOrgContactDraft,
} from "@shared/helpers/volunteer-organization";

export async function syncVolunteerOrgContacts(
  volunteerOrganizationId: string,
  drafts: VolunteerOrgContactDraft[],
) {
  const normalized = normalizeVolunteerOrgContactDrafts(drafts);
  const existing = await volunteerOrganizationContactRepo.find({
    where: { volunteerOrganizationId },
    limit: 200,
  });
  const kept = new Set<string>();

  for (const row of normalized) {
    const payload = {
      roleKind: row.roleKind,
      roleLabel: row.roleLabel,
      name: row.name || null,
      phone: row.phone || null,
      email: row.email || null,
      sortOrder: row.sortOrder,
    };
    const match = row.id
      ? existing.find((item) => item.id === row.id)
      : row.roleKind === "other"
        ? undefined
        : existing.find(
            (item) => item.roleKind === row.roleKind && !kept.has(item.id),
          );
    if (match) {
      kept.add(match.id);
      await volunteerOrganizationContactRepo.update(match.id, payload);
    } else {
      const created = await volunteerOrganizationContactRepo.insert({
        volunteerOrganizationId,
        ...payload,
      });
      kept.add(created.id);
    }
  }

  await Promise.all(
    existing
      .filter((item) => !kept.has(item.id))
      .map((item) => volunteerOrganizationContactRepo.delete(item.id)),
  );
}
